import { useEffect, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Subscribe to backend SSE stream and dispatch events to handlers.
 * @param {Record<string, (data: any) => void>} handlers map of event_type → callback
 */
export const useRealtimeEvents = (handlers) => {
  const { user, token } = useAuth();
  const handlersRef = useRef(handlers);

  useEffect(() => {
    handlersRef.current = handlers;
  });

  useEffect(() => {
    if (!user || !token) {
      return undefined;
    }
    const url = `${API}/events/stream?token=${encodeURIComponent(token)}`;
    const es = new EventSource(url);

    const listeners = {};
    Object.keys(handlersRef.current || {}).forEach((eventType) => {
      const fn = (ev) => {
        try {
          const data = JSON.parse(ev.data || "{}");
          handlersRef.current[eventType]?.(data);
        } catch { /* ignore */ }
      };
      listeners[eventType] = fn;
      es.addEventListener(eventType, fn);
    });

    es.onerror = () => {
      // EventSource auto-reconnects; nothing to do
    };

    return () => {
      Object.entries(listeners).forEach(([type, fn]) => es.removeEventListener(type, fn));
      es.close();
    };
  }, [user, token]);
};
